var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFbIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 18.5,
    r: 18.5,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4884 11.9335C15.4884 8.12485 17.2093 5.50114 20.6512 5.1626H24.5233V9.03469C22.8024 8.94549 19.7907 8.94549 19.7907 11.6161V14.4725V14.8957H24.5233V19.5507H19.7907V30.9766H15.4884V19.5507H10.7559V14.8957H15.4884V11.9335Z",
    fill: "#FBF9F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4884 19.5507V30.9766H19.7907V19.5507H24.5233V14.8957H19.7907V14.4725V11.6161C19.7907 8.94549 22.8024 8.94549 24.5233 9.03469V5.1626H20.6512C17.2093 5.50114 15.4884 8.12485 15.4884 11.9335V14.8957M15.4884 19.5507H10.7559V14.8957H15.4884M15.4884 19.5507V14.8957",
    stroke: "#FBF9F9",
    strokeWidth: 0.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbIcon);
export default __webpack_public_path__ + "static/media/FB_icon.a64aa8065cc2a97653d272e66fb8ac71.svg";
export { ForwardRef as ReactComponent };